import React from 'react';

export default function Blog011() {
  return (
    <section>
    <article>
      <h2>11. 08-23-2022</h2>
      <h3>Lists and Tutorials</h3>
      <p> 
        Hey! <br /><br />
        <br /><strong>Making a list.</strong><br />
        I have written out my two year plan. Within that two years I have set 
        milestone goals at the 3 month, 6 month, 1 year, and 2 year mark. 
        To meet these goals I started a monthly goal list with an end result
        that meets the standard set by the 3 month goal. <br />
        To meet the goal for this month I have written out a daily
         goal checklist. If I keep on top of my daily list I will stay 
         on track and meet the months goal. From here I will rewrite
          my daily todo list according to criteria of the month. <br />
          The plan is to continue this cycle. Planning long term will help
          reduce time spent planning in the short term, in theory.
          <br />   <br /> 
          <strong>Tutorials.</strong><br />
        I recorded the weekly Vlog yesterday, shortly after recording the blog.<br /> Make sure to check it 
        out in the links posted below this blog post! <br /><br />
        I have been learning a lot with tutorials, videos, and books. I have picked up a lot of advice along the way. One piece of advice is to create learning material on that which you have learned. Nothing states understanding more than relaying the information in an easily digestible format. <br />
        I have created tutorial videos in the past when my focus was a career in animation. I am familiar with the concept and I would like to apply the same idea to programming. <br />
        I am going to create a list of tutorial ideas. This list will need editing and prioritizing, but it will be a good starting point. <br />
        Before I start my list I would like to think of a recurring theme or rule. Something like ‘in 80 seconds’. <br /> Example: ‘Create a web page in 80 seconds!’ <br /> <br />
        I was writing the above statement as an example, but I am happy with that rule, so let’s go for it. My current plan is that I will start making a list here, and revisit this list in a later blog to properly edit, explain, and prioritize the tutorials. 
        <br />
        </p>
        <ul>
        <li>how to choose a Language. (What do you want to do? What language does that?)</li>
        <li>I decided to learn web dev. Now what? (freecodecamp, odin proj, warrior.js, codewars, leetcode, hackerRank, books, code, and of course tutorials like this.)</li>
        <li>VS Code and extensions (prettier, boilerplate, live server)</li>
        <li>Make your first webpage (or boilerplate)</li>
        <li>Make Text appear with HTML (h1-h6, p, etc.) </li>
        <li>add an image to your html web page</li>
        <li>link your web pages together HTML / web page</li>
        <li>Make page index links with id tags</li>
        <li>fieldset, forms, input, button</li>
        <li>id and class</li>
        <li>style and style.css</li>
        <li>make a box with css</li>
        <li>change web page background</li>
        <li>how to use a flex css</li>
        <li>how to use a grid css</li>
        <li>Make a floating Navbar</li>

        </ul>
        <p>
        
        
        <br />

      </p> 
    </article>
  
    <h4>Links</h4>
    <br />
    <ul>

      <li>
        <a
          href="https://www.youtube.com/watch?v=6IIY9qJnUXA&list=PLce5_YZyrUw7dNEL7F1T4kxAp0mMuattO&index=1"
          title="Vlog"
          target="_blank"
          rel="noopener noreferrer" 
        >
          <strong><p>THE VLOG - Video Blog Series</p></strong></a
        >
      </li>
      
      <li>
        <a
          href="http://erpolley.com"
          title="Check out my website"
          target="_blank"
          rel="noopener noreferrer" 
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    </ul>
  </section>
  )
}
